class TabbedContent extends HTMLElement {
  connectedCallback() {
    this.contentHeight = 0;
    this.content = this.querySelector('tabbed-items');
    if(!this.content) {
      throw new Error('No tabbed content found.');
    }
    this.tabs = this.querySelectorAll('.tabbed-button');
    if(this.tabs.length === 0) {
      throw new Error('No tab buttons found.');
    } 
    this.items = this.content.querySelectorAll(':scope > .column-block');
    if(this.items.length === 0) {
      throw new Error('No tabbed content found.');
    }
    this.setItemHeights();
    window.addEventListener('resize', this.setItemHeights.bind(this));
    this.tabs.forEach((i,k) => {
      i.setAttribute('date-state', 'inactive');
      i.addEventListener('click', this.handleSelectTab.bind(this, k))
    })
    this.selectTab(0);
  }

  handleSelectTab(index, e) {
    e.preventDefault();
    this.selectTab(index);
  }

  selectTab(index) {
    this.querySelector('.tabbed-button[data-state="active"]')?.setAttribute('data-state', 'inactive');
    this.content.querySelector(':scope > .column-block[data-state="active"]')?.setAttribute('data-state', 'inactive');
    const content = this.items[index];
    const button = this.tabs[index];
    const height = this.itemHeights[index];
    if(!content || !button || !height) {
      throw new Error('Misaligned tab count.');
    }
    content.setAttribute('data-state', 'active');
    button.setAttribute('data-state', 'active');
    this.content.style.setProperty('height', `${height}px`);
    this.selectedTab = index;
  }

  setItemHeights() {
    this.itemHeights = [];
    this.items.forEach((i,k) => {
      const height = this.calcHeight(i);
      if(height === 0) {
        this.setButtonEmpty(k, 'true');
        return;
      }
      this.itemHeights[k] = height;
      this.setButtonEmpty(k, 'false');
      if(this.selectedTab === k) {
        this.content.style.setProperty('height', `${height}px`);
      }
    });
  }

  setButtonEmpty(index, isEmpty) {
    this.tabs[index]?.closest('.tabbed-button-wrapper')?.setAttribute('data-empty', `${isEmpty}`);
  }

  setVisibility(content) {
    if(content.children.length === 0) {
      content.style.opacity = 0;
      setTimeout(() => {
        content.style.display = 'none';
      }, 150)
      return false;
    }
    else {
      content.style.display = 'flex';
      setTimeout(() => {
        content.style.opacity = 1;
      }, 100)
    }
    return true;
  }

  calcHeight(content) {
    if(!this.setVisibility(content)) return 0;
    return calcHeight(content, this.content, 'flex');
  }
}

customElements.define('tabbed-content', TabbedContent);